import {useEffect, useRef} from 'react';

export const useAutoFocus = (isOpen: boolean, delay: number = 300) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        ref.current?.focus();
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [isOpen, delay]);

  return ref;
};
